export default __webpack_public_path__ + "static/media/text-size-decrease.c3e1521e.svg";